import React from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import Details from "./Details/Details";
import { basicTempData } from '../../DefaultPropTypes';

export const SecondaryInfo = props => {
  return (
    <Details
      header="Secondary Advisor"
      basicInfo={props.tempData.tempJSON.advisors[1]}
      phoneInfo={props.tempData.tempJSON.advisors[1].phones}
      emailInfo={props.tempData.tempJSON.advisors[1].emails}
      addressInfo={props.tempData.tempJSON.advisors[1].addresses}
    />
  );
};

const mapStateToProps = state => ({
  tempData: state.getIn(["npaFormReducer", "tempJSON", "tempJSON"])
});

SecondaryInfo.propTypes = {
  dispatch: PropTypes.func,
  tempData: basicTempData
}

export default connect(mapStateToProps)(SecondaryInfo);
